export default "__VITE_ASSET__DfZkxB5a__"